enum FigureColor {
  Black = 'Black',
  White = 'White'
}

export default FigureColor